import { useRouteError } from 'react-router-dom';
import { ErrorDisplay } from '@shared/components/ErrorDisplay.tsx';

/** errorElement compartido por todas las rutas del router. */
export function RouteError() {
  const error = useRouteError();
  return (
    <div className="p-4">
      <ErrorDisplay
        title="Error en la aplicación"
        message={error instanceof Error ? error.message : 'Error desconocido'}
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
